import type { GatsbyBrowser } from 'gatsby';
import './src/fonts/fonts.css';

declare global {
  // eslint-disable-next-line no-unused-vars
  interface Window {
    SignUpFormWidget: {
      main: () => void;
      [key: string]: unknown;
    }
  }
}

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = ({ location }) => {
  if (location.pathname === '/' && window.SignUpFormWidget)
    window.SignUpFormWidget.main();
};
